import { render, staticRenderFns } from "./Wonderful.vue?vue&type=template&id=d2327728&scoped=true&"
import script from "./Wonderful.vue?vue&type=script&lang=ts&"
export * from "./Wonderful.vue?vue&type=script&lang=ts&"
import style0 from "./Wonderful.vue?vue&type=style&index=0&id=d2327728&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2327728",
  null
  
)

export default component.exports